import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="15" height="22" viewBox="0 0 14.0619 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 12.2228C0 12.0105 0.0868612 11.7917 0.260584 11.5665L9.2845 0.419347C9.45822 0.200585 9.64481 0.0686847 9.84427 0.0236456C10.0437 -0.0213936 10.2239 -0.00209111 10.3847 0.0815531C10.5456 0.165197 10.6582 0.303532 10.7225 0.496557C10.7869 0.683148 10.7676 0.905126 10.6646 1.16249L7.73065 9.07652H13.3187C13.5375 9.07652 13.7144 9.14408 13.8495 9.27919C13.9911 9.40788 14.0619 9.57517 14.0619 9.78106C14.0619 9.99339 13.975 10.2089 13.8013 10.4277L4.77737 21.5845C4.60365 21.7969 4.41705 21.9255 4.2176 21.9706C4.01814 22.0221 3.83798 22.006 3.67713 21.9223C3.51627 21.8387 3.40367 21.7004 3.33933 21.5073C3.27499 21.3207 3.29429 21.0955 3.39724 20.8317L6.33122 12.9177H0.743146C0.524385 12.9177 0.344228 12.8534 0.202676 12.7247C0.0675587 12.5896 0 12.4223 0 12.2228Z" fill="#E15CF7"/>
</svg>
`;

export const InstantUnlockIcon = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
